export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

const PHONE = "(678) 431-1203";

export const locations: LocationData[] = [
  {
    slug: "lawrenceville",
    name: "Lawrenceville",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: true,
    lat: 33.9562,
    lng: -83.988,
    description:
      "F&T Renovations is based in Lawrenceville, GA. Painting, bathroom remodels, flooring, decks and basement finishing for Gwinnett County homeowners — six years in, and most of our work still comes from neighbours talking to neighbours.",
    highlights: [
      "Based in Lawrenceville, GA",
      "6 years of remodeling experience",
      "Free written estimates",
      "10% off jobs over $2,000",
    ],
    content: [
      "Lawrenceville is home. We know the housing stock here — the 1990s and 2000s subdivisions off Sugarloaf Parkway, the older homes near the historic square, and the newer builds pushing out toward Dacula. Each one ages differently, and that tells us what to check before we quote.",
      "The work that keeps us busiest in Lawrenceville is interior repainting, bathroom renovations and finishing basements that builders left as bare shells. We self-perform painting, tile, drywall, flooring, plumbing and electrical, so a full bathroom or basement runs on one schedule with one crew instead of five subcontractors you have to chase.",
      `Call ${PHONE} for a free, no-pressure estimate anywhere in Lawrenceville.`,
    ],
    cities: [
      { name: "Downtown Lawrenceville", lat: 33.9562, lng: -83.988 },
      { name: "Sugarloaf", lat: 33.9686, lng: -84.0563 },
      { name: "Five Forks", lat: 33.8912, lng: -84.0338 },
      { name: "Dacula", lat: 33.9887, lng: -83.8985 },
    ],
  },
  {
    slug: "alpharetta",
    name: "Alpharetta",
    state: "GA",
    region: "North Fulton County",
    isPrimary: false,
    lat: 34.0754,
    lng: -84.2941,
    description:
      "Remodeling and painting in Alpharetta, GA. Bathroom renovations, interior and exterior painting, hardwood flooring, tile work and basement finishing — with written quotes and a crew that cleans up daily.",
    highlights: [
      "Bathroom & basement renovations",
      "Interior and exterior painting",
      "Hardwood, LVP and tile installation",
      "Free written estimates",
    ],
    content: [
      "Alpharetta homeowners tend to renovate with resale in mind, and that shapes the work we do here: neutral repaints that photograph well, updated bathrooms, and hardwood or LVP replacing worn carpet throughout the main floor.",
      "We handle the full scope on Alpharetta projects — demo, plumbing and electrical rough-in, waterproofing, tile, drywall, trim and paint. Because it is all in-house, there is no gap between trades where a job sits untouched for a week.",
      `Book a free Alpharetta estimate at ${PHONE}.`,
    ],
    cities: [
      { name: "Avalon", lat: 34.0708, lng: -84.2716 },
      { name: "Downtown Alpharetta", lat: 34.0754, lng: -84.2941 },
      { name: "Windward", lat: 34.1044, lng: -84.2585 },
      { name: "Milton", lat: 34.1323, lng: -84.3007 },
    ],
  },
  {
    slug: "johns-creek",
    name: "Johns Creek",
    state: "GA",
    region: "North Fulton County",
    isPrimary: false,
    lat: 34.0289,
    lng: -84.1986,
    description:
      "Johns Creek, GA remodeling contractor. Full bathroom renovations, tile work, flooring, painting, decks and finished basements for homes across Johns Creek.",
    highlights: [
      "Full bathroom renovations",
      "Large-format and stone tile work",
      "Deck rebuilds and repair",
      "Finished basement build-outs",
    ],
    content: [
      "Johns Creek homes are largely 1990s and 2000s builds, which means we see a consistent set of projects: original builder-grade bathrooms ready for a gut renovation, oak floors due for refinishing or replacement, and decks that have taken twenty Georgia summers.",
      "Tile is a big part of what we do here — large-format porcelain, stone and mosaic in showers and on floors, always over a properly prepped and waterproofed substrate. That prep is invisible in photos and it is the entire reason a shower does not fail in year three.",
      `Call ${PHONE} for a free estimate in Johns Creek.`,
    ],
    cities: [
      { name: "Medlock Bridge", lat: 34.0004, lng: -84.2098 },
      { name: "St. Ives", lat: 34.0163, lng: -84.196 },
      { name: "Ocee", lat: 34.0462, lng: -84.2201 },
      { name: "Newtown", lat: 34.0324, lng: -84.174 },
    ],
  },
  {
    slug: "roswell",
    name: "Roswell",
    state: "GA",
    region: "North Fulton County",
    isPrimary: false,
    lat: 34.0232,
    lng: -84.3616,
    description:
      "Roswell, GA painting and remodeling. Interior and exterior painting, bathroom renovations, flooring, drywall repair and deck work — including older and historic-district homes.",
    highlights: [
      "Interior & exterior repaints",
      "Bathroom and basement remodels",
      "Drywall and plaster repair",
      "Deck rebuild and staining",
    ],
    content: [
      "Roswell has real range — historic homes near Canton Street, mid-century ranches, and newer subdivisions east toward the river. Older homes need a different approach: settled cracks, plaster repair and previously painted trim all get handled before any finish coat goes on.",
      "Exterior painting is a strong seasonal service for us in Roswell. Siding, soffit, fascia and trim get scraped, sanded, primed and caulked, because on an exterior the prep is what buys you the extra five years.",
      `Get your free Roswell estimate at ${PHONE}.`,
    ],
    cities: [
      { name: "Historic Roswell", lat: 34.0232, lng: -84.3616 },
      { name: "Martin's Landing", lat: 34.0087, lng: -84.3333 },
      { name: "Crabapple", lat: 34.0752, lng: -84.3499 },
      { name: "East Roswell", lat: 34.0338, lng: -84.3086 },
    ],
  },
  {
    slug: "buford",
    name: "Buford",
    state: "GA",
    region: "Gwinnett & Hall County",
    isPrimary: false,
    lat: 34.1206,
    lng: -83.9946,
    description:
      "Buford, GA remodeling and painting. Basement finishing, bathroom renovations, flooring, decks and Sheetrock repair for homes around Buford and the Mall of Georgia corridor.",
    highlights: [
      "Basement finishing specialists",
      "Bathroom and full-home remodels",
      "Deck builds and repairs",
      "Sheetrock hanging and repair",
    ],
    content: [
      "Buford has grown fast, and a lot of that growth is homes built with unfinished basements. Finishing one is the cheapest square footage a homeowner around here will ever add — we take it from bare block through framing, electrical, plumbing, drywall, flooring, trim and paint.",
      "We also handle the smaller jobs that keep a house right: patching Sheetrock after a leak, replacing worn flooring, repainting a room before it goes on the market, and rebuilding deck framing that has started to soften.",
      `Call ${PHONE} for a free estimate in Buford.`,
    ],
    cities: [
      { name: "Mall of Georgia", lat: 34.0672, lng: -83.9803 },
      { name: "Hamilton Mill", lat: 34.0562, lng: -83.9161 },
      { name: "Sugar Hill", lat: 34.1065, lng: -84.0335 },
      { name: "Downtown Buford", lat: 34.1206, lng: -83.9946 },
    ],
  },
  {
    slug: "suwanee",
    name: "Suwanee",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: false,
    lat: 34.0515,
    lng: -84.0713,
    description:
      "Suwanee, GA remodeling contractor. Painting, bathroom renovations, tile, flooring, basements and decks — free written estimates and a 10% discount on jobs over $2,000.",
    highlights: [
      "Painting and full-home refreshes",
      "Bathroom and basement renovations",
      "Tile and flooring installation",
      "10% off jobs over $2,000",
    ],
    content: [
      "Suwanee is a short drive from our shop in Lawrenceville, which means we can get out for an estimate quickly and keep crews on site consistently rather than bouncing between distant jobs.",
      "Most of our Suwanee work is interior: repainting main living areas, replacing carpet with LVP or hardwood, renovating primary bathrooms, and finishing basements into media rooms and home offices.",
      `Request a free Suwanee estimate at ${PHONE}.`,
    ],
    cities: [
      { name: "Suwanee Town Center", lat: 34.0515, lng: -84.0713 },
      { name: "Old Town Suwanee", lat: 34.0518, lng: -84.0742 },
      { name: "Settles Bridge", lat: 34.0855, lng: -84.075 },
      { name: "Sugarloaf", lat: 34.0035, lng: -84.0678 },
    ],
  },
  {
    slug: "flowery-branch",
    name: "Flowery Branch",
    state: "GA",
    region: "Hall County",
    isPrimary: false,
    lat: 34.1851,
    lng: -83.9252,
    description:
      "Flowery Branch, GA remodeling and painting. Decks, basements, bathrooms, flooring and interior painting for homes around Flowery Branch and Lake Lanier.",
    highlights: [
      "Deck builds, rebuilds & staining",
      "Basement finishing",
      "Bathroom renovations",
      "Interior & exterior painting",
    ],
    content: [
      "Flowery Branch and the Lake Lanier area is deck country. Sun, humidity and rain cycle hard on outdoor structures here, so we spend as much attention on ledger flashing, footings and framing as we do on the boards you actually see.",
      "Inside, we handle the same full scope as everywhere else we work — bathrooms, flooring, tile, Sheetrock and painting — with plumbing and electrical done in-house so remodels do not stall waiting on another trade.",
      `Call ${PHONE} for a free Flowery Branch estimate.`,
    ],
    cities: [
      { name: "Downtown Flowery Branch", lat: 34.1851, lng: -83.9252 },
      { name: "Sterling on the Lake", lat: 34.1683, lng: -83.9078 },
      { name: "Oakwood", lat: 34.2273, lng: -83.8846 },
      { name: "Lake Lanier", lat: 34.2071, lng: -83.9585 },
    ],
  },
  {
    slug: "duluth",
    name: "Duluth",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: false,
    lat: 34.0029,
    lng: -84.1446,
    description:
      "Duluth, GA painting and remodeling. Interior painting, bathroom renovations, flooring, tile, drywall repair and basement finishing across Duluth.",
    highlights: [
      "Interior and exterior painting",
      "Bathroom and kitchen-area tile",
      "Hardwood and LVP flooring",
      "Drywall repair and texture matching",
    ],
    content: [
      "Duluth mixes established neighbourhoods with townhome and condo communities, and each brings its own work. Townhomes tend to need paint, flooring and bathroom updates; older single-family homes bring drywall repair, deck work and full renovations.",
      "Texture matching matters a lot in Duluth's older interiors — a patch that is flat against a textured wall stands out under every light in the room, so we match the surrounding finish before priming.",
      `Book your free Duluth estimate at ${PHONE}.`,
    ],
    cities: [
      { name: "Downtown Duluth", lat: 34.0029, lng: -84.1446 },
      { name: "Sugarloaf", lat: 33.9808, lng: -84.1099 },
      { name: "Berkeley Lake", lat: 33.9812, lng: -84.1866 },
    ],
  },
  {
    slug: "peachtree-corners",
    name: "Peachtree Corners",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: false,
    lat: 33.97,
    lng: -84.2216,
    description:
      "Peachtree Corners, GA remodeling contractor. Bathroom renovations, painting, flooring, tile work, decks and finished basements with free written estimates.",
    highlights: [
      "Bathroom and basement renovations",
      "Interior repaints and trim work",
      "Tile floors, showers & backsplashes",
      "Deck repair and rebuilds",
    ],
    content: [
      "Peachtree Corners has a lot of homes from the 1970s through the 1990s, which is right in the window where original bathrooms, decks and flooring are all due at once. That is exactly the kind of multi-trade project we are set up for.",
      "Rather than quoting a bathroom and leaving the drywall and paint to someone else, we price the whole thing — demo through final coat — so there is no seam in the schedule and no argument about who is responsible for what.",
      `Call ${PHONE} for a free Peachtree Corners estimate.`,
    ],
    cities: [
      { name: "Technology Park", lat: 33.9739, lng: -84.2249 },
      { name: "Peachtree Station", lat: 33.9846, lng: -84.2247 },
      { name: "Town Center", lat: 33.97, lng: -84.2216 },
    ],
  },
  {
    slug: "lilburn",
    name: "Lilburn",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: false,
    lat: 33.8901,
    lng: -84.143,
    description:
      "Lilburn, GA painting and remodeling. Interior and exterior painting, Sheetrock repair, flooring, bathrooms and deck work for Lilburn homeowners.",
    highlights: [
      "Interior & exterior painting",
      "Sheetrock and ceiling repair",
      "Flooring replacement",
      "Bathroom renovations",
    ],
    content: [
      "Lilburn's housing is largely established — ranches and split-levels from the 1970s and 1980s with a lot of original surfaces still in place. Popcorn ceiling removal, drywall repair and full interior repaints are constant requests here.",
      "We also handle the water-damage repairs that come with older roofs and plumbing: cut back the damaged board, fix the source, re-hang, finish, texture and paint so the repair disappears.",
      `Get a free Lilburn estimate at ${PHONE}.`,
    ],
    cities: [
      { name: "Old Town Lilburn", lat: 33.8901, lng: -84.143 },
      { name: "Killian Hill", lat: 33.8783, lng: -84.129 },
      { name: "Rockbridge", lat: 33.8538, lng: -84.1252 },
    ],
  },
  {
    slug: "norcross",
    name: "Norcross",
    state: "GA",
    region: "Gwinnett County",
    isPrimary: false,
    lat: 33.9412,
    lng: -84.2135,
    description:
      "Norcross, GA remodeling and painting contractor. Bathrooms, flooring, tile, Sheetrock, plumbing, electrical and painting for homes throughout Norcross.",
    highlights: [
      "Full bathroom renovations",
      "Tile and flooring installation",
      "Plumbing & electrical in-house",
      "Free written estimates",
    ],
    content: [
      "Norcross runs from historic homes near the downtown district to newer subdivisions along Peachtree Industrial. We work on both, and the approach is the same either way: check what is behind the surface before quoting what goes on top of it.",
      "Because we self-perform plumbing and electrical, Norcross bathroom and basement projects do not stall between trades. One crew, one schedule, one person to call.",
      `Call ${PHONE} for a free Norcross estimate.`,
    ],
    cities: [
      { name: "Historic Norcross", lat: 33.9412, lng: -84.2135 },
      { name: "Jimmy Carter Blvd", lat: 33.9147, lng: -84.2035 },
      { name: "Beaver Ruin", lat: 33.9268, lng: -84.1704 },
    ],
  },
  {
    slug: "buckhead",
    name: "Buckhead",
    state: "GA",
    region: "Atlanta · Fulton County",
    isPrimary: false,
    lat: 33.8484,
    lng: -84.3733,
    description:
      "Buckhead, Atlanta remodeling and painting. High-finish interior painting, bathroom renovations, tile work, flooring and condo remodels in Buckhead.",
    highlights: [
      "High-finish interior painting",
      "Bathroom renovations & tile",
      "Condo and townhome remodels",
      "Hardwood and stone flooring",
    ],
    content: [
      "Buckhead is our furthest regular service area and the work here skews toward finish quality: crisp trim lines, smooth walls, stone and large-format tile, and floors that have to look right in a lot of natural light.",
      "Condo and high-rise projects come with their own constraints — building access, elevator scheduling, work-hour restrictions and protecting common areas. We plan around them rather than discovering them on day one.",
      `Call ${PHONE} for a free estimate in Buckhead.`,
    ],
    cities: [
      { name: "Buckhead Village", lat: 33.8484, lng: -84.3733 },
      { name: "Garden Hills", lat: 33.8321, lng: -84.373 },
      { name: "Chastain Park", lat: 33.8797, lng: -84.3833 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
